//ThinkleticsUpdatePoints
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';
import MainLayout from '../../../layouts/MainLayout';
import '../styles/MCQPractice.css';
import '../styles/ThinkleticsTables.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import Loader from '../../../components/utils/Loader';
import Tooltip from '../../../components/utils/Tooltip';
// import { GenerateThinkleticsEventEnrollmentNumber, GenerateThinkleticsTeamCode } from '../../../components/GenerateThink5whysCode';
// import { getUserByThink5whysCode } from '../../../../../backend/controllers/userDataControllers';

const ThinkleticsUpdatePoints = () => {
    const authState = useSelector(state => state.authReducer);
    const location = useLocation();
    const { userData } = location.state || {};
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    // console.log("UserDate in the update page",userData);

    const formattedDateTime = (date) => {
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
        };
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const hours = jsDate.getHours().toString().padStart(2, '0');
        const minutes = jsDate.getMinutes().toString().padStart(2, '0');
        const seconds = jsDate.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };
        
    const [buttonAssignmentCountDisabled, setButtonAssignmentCountDisabled] = useState(false);
    const handleAssignmentCountClick  = () => {
        setButtonAssignmentCountDisabled(true);
        fetchAssignmentCount();
    };

    const [assignmentCount, setAssignmentCount] = useState(0);
    const [assignmentCountMsg, setAssignmentCountMsg] = useState('');
    const fetchAssignmentCount = async () => {
        const today=new Date();
        const fromDate= userData.dateCreated;
        const config = {
                url: "/assignment/countbydaterange",
                method: "post",
                headers: { Authorization: authState.token  },
                data: { user: userData.userId, fromDate: fromDate, toDate: today}
            };
            // console.log("Request Payload for /assignment/countbydaterange: ",userData.userId, fromDate, today );

            fetchData(config, { showSuccessToast: false })
                .then(response => {
                    // console.log("response for /assignment/countbydaterange: ",response);

                    if (response && response.status) {
                        // console.log("inside /assignment/countbydaterange ", response.assignmentCount);
                        setAssignmentCount(response.assignmentCount);
                        setAssignmentCountMsg("Successfully fetched assignment count.");
                        updateAssignmentCount(userData._id,response.assignmentCount);
                    } else {
                        console.error("Error In Assignment Count: ", response.msg);
                        setAssignmentCountMsg("Error! fetching assignment count.");
                    }
                })
                .catch(error => {
                    console.error("Error! fetching assignment count: ", error);
                });
    };

    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchAssignmentCount]);

    const updateAssignmentCount = async (_id,assignmentCount) => {
        const assignmentCountSyncDate = new Date();
        const config = {
                url: `/thinkleticsusers/updateassignmentcount/${userData._id}`,
                method: "put",
                headers: { Authorization: authState.token  },
                data: { assignmentCount: assignmentCount, assignmentCountSyncDate: assignmentCountSyncDate }
            };
            // console.log("Request Payload for /thinkleticsusers/updateassignmentcount: ",_id, assignmentCount, assignmentCountSyncDate );

            fetchData(config, { showSuccessToast: false })
                .then(response => {
                    // console.log("response for /thinkleticsusers/updateassignmentcount: ",response);

                    if (response && response.status) {
                        // console.log("inside /thinkleticsusers/updateassignmentcount ", response.status);
                    } else {
                        console.error("Error In Updating Assignment Count: ", response.msg);
                    }
                })
                .catch(error => {
                    console.error("Error! Updating Assignment Count: ", error);
                });
        };

        useEffect(() => {
            if (!authState.isLoggedIn) return;
        }, [authState.isLoggedIn, updateAssignmentCount]);

    const [buttonMCQPracticeCountDisabled, setButtonMCQPracticeCountDisabled] = useState(false);
    const handleMCQPracticeCountClick  = () => {
        setButtonMCQPracticeCountDisabled(true);
        fetchMCQCount();
    };


    // const [updateCertificateInfoDisabled, setUpdateCertificateInfoDisabled] = useState(false);
    // const handleUpdateCertificateInfoClick  = () => {
    //     setUpdateCertificateInfoDisabled(true);
    //     fetchCertificateInfo();
    // };

    const [updateRCAEntryCountDisabled, setUpdateRCAEntryCountDisabled] = useState(false);
    const handleUpdateRCAEntryCountClick  = () => {
        setUpdateRCAEntryCountDisabled(true);
        fetchUpdateRCACount();
    };

    const [updateLCEntryCountDisabled, setUpdateLCEntryCountDisabled] = useState(false);
    const handleUpdateLCEntryCountClick  = () => {
        setUpdateLCEntryCountDisabled(true);
        fetchUpdateLCCount();
    };

    const [updateBookPageReadCountDisabled, setUpdateBookPageReadCountDisabled] = useState(false);
    const handleUpdateBookPageReadCountClick  = () => {
        setUpdateBookPageReadCountDisabled(true);
        fetchUpdateBookPageReadCount();
    };

    const [updateRCALCLinkCountDisabled, setUpdateRCALCLinkCountDisabled] = useState(false);
    const handleUpdateRCALCLinkCountClick  = () => {
        setUpdateRCALCLinkCountDisabled(true);
        fetchUpdateLCCount();
    };

    const [updateSpotSnapCountDisabled, setUpdateSpotSnapCountDisabled] = useState(false);
    const handleUpdateSpotSnapCountClick  = () => {
        setUpdateSpotSnapCountDisabled(true);
        fetchUpdateSpotSnapCount();
    };

    const [updateFocusTimerCountDisabled, setUpdateFocusTimerCountDisabled] = useState(false);
    const handleUpdateFocusTimerCountClick  = () => {
        setUpdateFocusTimerCountDisabled(true);
        fetchUpdateFocusTimerCount();
    };

    const [updateVBCountDisabled, setUpdateVBCountDisabled] = useState(false);
    const handleUpdateVBCountClick  = () => {
        setUpdateVBCountDisabled(true);
        fetchUpdateVBCount();
    };

    const [updatePovifyCountDisabled, setUpdatePovifyCountDisabled] = useState(false);
    const handleUpdatePovifyCountClick  = () => {
        setUpdatePovifyCountDisabled(true);
        fetchUpdatePovifyCount();
    };

    const [updateBookBuyCountDisabled, setUpdateBookBuyCountDisabled] = useState(false);
    const handleUpdateBookBuyCountClick  = () => {
        setUpdateBookBuyCountDisabled(true);
        fetchUpdateBookBuyCount();
    };

    const [updateBookGiftCountDisabled, setUpdateBookGiftCountDisabled] = useState(false);
    const handleUpdateBookGiftCountClick  = () => {
        setUpdateBookGiftCountDisabled(true);
        fetchUpdateBookGiftCount();
    };

return (
    <MainLayout>
        <div className='mb-4'>
            <h3 className='text-lg mt-1 mx-2 border-b border-b-gray-300 text-white'>Thinkletics Sync / Update Points</h3>
        </div>
        <div className="main-content text-white mt-4 mb-4 mr-4 ml-4 border border-gray-300">
            <div>
                <p className="mb-4 text-xl text-center text-yellow-500">Sometime Thinkletics Points Table Data May Not Be In Sync Due To Various Reasons. Sync Your Activity Data Points Needed For Thinkletics Ranking</p>
            </div>
            <div className='ml-4 text-white'>
                <div className='mb-4'>   
                    <div className='flex justify-center'>
                        <p><strong>[User Code :</strong> {userData.userCode}]</p>
                    </div>
                    <div className='flex justify-center'>
                        <p className='text-white'><strong >Date Enrolled:</strong> {formattedDateTime(userData.enrollmentDate)}</p>
                    </div>
                </div> 
                <div className='mb-4'>
                    <table className="responsive-table">
                        <thead>
                        <tr>
                            <th>Particulars</th>
                            <th>Points Earned</th>
                            <th>Sync Date</th>
                            <th>Sync</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className='text-yellow-200'>Total</td>
                            <td className='text-yellow-200'><strong >{userData.totalPoints}</strong></td>
                            <td>Last Updated</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>1. Activation</td>
                            <td>{userData.enrollmentPoints}</td>
                            <td>{userData.enrollmentDate ? formattedDateTime(userData.enrollmentDate): ""}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>2. Think5Whys Main Book Purchase </td>
                            <td>{userData.purchasePoints}</td>
                            <td>{userData.purchaseDate ? formattedDateTime(userData.purchaseDate) : ""}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>3. Assignment</td>
                            <td>{userData.assignmentPoints}</td>
                            <td>{userData.assignmentCountSyncDate? formattedDateTime(userData.assignmentCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleAssignmentCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>4. Practice MCQ</td>
                            <td>{userData.practiceMCQPoints}</td>
                            <td>{userData.practiceMCQCountSyncDate ? formattedDateTime(userData.practiceMCQCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleMCQPracticeCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>5. Certification Test</td>
                            <td>{userData.certificationTestPoints}</td>
                            <td>{userData.certificateDate ? formattedDateTime(userData.certificateDate) : ""}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>6. Event Qualification</td>
                            <td>{userData.registrationPoints}</td>
                            <td>{userData.registrationDate ? formattedDateTime(userData.registrationDate) : ""}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>7. RCA Entry</td>
                            <td>{userData.rcaEntryPoints}</td>
                            <td>{userData.rcaEntryCountSyncDate ? formattedDateTime(userData.rcaEntryCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleUpdateRCAEntryCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>8. LC Entry</td>
                            <td>{userData.lcEntryPoints}</td>
                            <td>{userData.lcEntryCountSyncDate ? formattedDateTime(userData.lcEntryCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleUpdateLCEntryCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>9. RCA LC Link Entry</td>
                            <td>{userData.rcaLCLinkEntryPoints}</td>
                            <td>{userData.rcaLCLinkEntryCountSyncDate ? formattedDateTime(userData.rcaLCLinkEntryCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleUpdateRCALCLinkCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>10. Book Page Read</td>
                            <td>{userData.bookPageReadPoints}</td>
                            <td>{userData.bookPageReadCountSyncDate ? formattedDateTime(userData.bookPageReadCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleUpdateBookPageReadCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>11. Spot Snap</td>
                            <td>{userData.spotSnapPoints}</td>
                            <td>{userData.spotSnapCountSyncDate ? formattedDateTime(userData.spotSnapCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleUpdateSpotSnapCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>12. Focus Timer</td>
                            <td>{userData.focusTimerPoints}</td>
                            <td>{userData.focusTimerCountSyncDate ? formattedDateTime(userData.focusTimerCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleUpdateFocusTimerCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>13. VisualBrief</td>
                            <td>{userData.vbEntryPoints}</td>
                            <td>{userData.vbEntryCountSyncDate ? formattedDateTime(userData.vbEntryCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleUpdateVBCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>14. POVify</td>
                            <td>{userData.povifyEntryrPoints}</td>
                            <td>{userData.povifyEntryCountSyncDate ? formattedDateTime(userData.povifyEntryCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleUpdatePovifyCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>15. Other Book Buy</td>
                            <td>{userData.bookBuyPoints}</td>
                            <td>{userData.bookBuyCountSyncDate ? formattedDateTime(userData.bookBuyCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleUpdateBookBuyCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>16. Book Gifting</td>
                            <td>{userData.bookGiftingPoints}</td>
                            <td>{userData.bookGiftingCountSyncDate ? formattedDateTime(userData.bookGiftingCountSyncDate) : ""}</td>
                            <td>
                                <FontAwesomeIcon
                                    icon={faSync}
                                    onClick={handleUpdateBookGiftCountClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </MainLayout>
);
};

export default ThinkleticsUpdatePoints;

